import React, { useState } from 'react';
import { Button, TextBox, Popup } from 'devextreme-react';
import { useHistory } from "react-router-dom";
import {
    Column,
    DataGrid,
    Editing,
    Selection
} from "devextreme-react/data-grid";
import data from "../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { connect } from "react-redux";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { confirm } from "devextreme/ui/dialog";
import { alert } from 'devextreme/ui/dialog';

const TwoFactorSettings = (props) => {
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowsData);
    }
    var accessToken = props.oidc.user.access_token;
    const history = useHistory();
    // Add a new 2FA method
    const handleAddMethod = () => {
        if(selectedItemKeys[0].isEnabled){
            alert('The 2FA is already enabled for ' +selectedItemKeys[0].method, "2FA Already Enabled");
            return;
        }
        const currentAppUrl = window.location.href; 
        const identityAppUrl = `${window._env_.REACT_APP_AUTH_URL}/${data.idp.EnableTwoFactorAuthenticator}?method=${selectedItemKeys[0].id}&currentUrl=${encodeURIComponent(currentAppUrl)}`;
        window.location.href = identityAppUrl;
    };

    const dataSource = createStore({
        key: 'id',
        loadUrl: `/idp/api/identity/twofactor`,
        deleteUrl: `/idp/api/identity/DeleteTwoFactorMethod`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
            };
        }
    });

    const onContentReady = async (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSource);
        }
    }
    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <Toolbar className="header">
                        <Item location="before">
                            <div className="title">
                                <h6
                                    style={{
                                        color: window._env_.Color2,
                                        marginLeft: '12px'
                                    }}
                                >
                                    Two-Factor Authentication Settings
                                </h6>
                            </div>
                        </Item>
                        <Item location="after">
                            <Button
                                text="Enable 2fa method"
                                type="default"
                                className="accordianButton"
                                onClick={handleAddMethod}
                                disabled={!selectedItemKeys.length}
                            />
                        </Item>
                    </Toolbar>

                    <div className='row'>
                        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} onContentReady={onContentReady}
                        onSelectionChanged={handleCellValueChanged}                       
                        onRowRemoving={(e) => {
                            if(e.data.isEnabled === false){
                                e.cancel = true
                                return;
                            }
                            e.cancel = new Promise((resolve) => {
                              confirm("Are you sure you want to remove this 2FA method?", "Remove DFA Method Confirmation")
                                .then((dialogResult) => {
                                  resolve(!dialogResult); // Resolve based on user choice
                                });
                            });
                          }}
                        >
                            
                            <Editing
                                mode="cell"
                                allowDeleting={true}
                                confirmDelete={false}
                            />
                            <Selection mode="single" />
                             <Column dataField="id" caption="Id" visible={false} />
                            <Column dataField="method" caption="2FA Method" />
                            <Column dataField="isEnabled" caption="Enabled" />
                        </DataGrid>
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(TwoFactorSettings);
